import React from 'react'

const Reopen = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.6667 6.66667H15.8333V2.5M15.5911 13.6308C14.8145 14.8265 13.6751 15.7418 12.3401 16.2423C11.0051 16.7428 9.54463 16.802 8.17342 16.4114C6.80221 16.0208 5.59258 15.2011 4.72168 14.0723C3.85077 12.9434 3.36482 11.565 3.33496 10.1396C3.3051 8.71412 3.73269 7.31668 4.55556 6.15234C5.37843 4.98801 6.55295 4.11833 7.9066 3.67065C9.26025 3.22298 10.7219 3.22083 12.0767 3.66496C13.4315 4.10909 14.6083 4.97579 15.4342 6.13796" stroke="#3249D7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default Reopen
